import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendReportFactory()
  .extendReportViewFactory('integration')
  .factory()

export {
  Provider as IntegrationReportProvider,
  useStore as useIntegrationReportStore,
}
